import { createFileRoute } from '@tanstack/react-router';
import { KnowledgePage } from '@/features/knowledge/KnowledgePage';

export const Route = createFileRoute('/knowledge')({
  component: KnowledgePage,
  validateSearch: (search) => ({
    signalIds: search.signalIds as string | undefined,
  }),
});
